import React from "react";
import { LocalKnobNumberInput } from "./LocalKnobNumberInput";

function SegmentButton({ active, onClick, children, disabled }) {
  return (
    <button
      type="button"
      className={[
        "ai-chat-local-segment-btn",
        active ? "ai-chat-local-segment-btn--active" : "",
      ].join(" ")}
      onClick={() => {
        if (disabled) return;
        onClick?.();
      }}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function LocalContextSizeControl({
  mode,
  min,
  max,
  onModeChange,
  onMinChange,
  onMaxChange,
  onMinBlur,
  onMaxBlur,
  isBusy,
}) {
  const isManual = mode === "manual";

  return (
    <div className="ai-chat-local-knob ai-chat-local-knob--context">
      <div className="ai-chat-local-knob-label">Context</div>

      <div className="ai-chat-local-knob-bottom">
        <div className="ai-chat-local-segmented">
          <SegmentButton
            active={mode === "auto"}
            onClick={() => onModeChange?.("auto")}
            disabled={isBusy}
          >
            Auto
          </SegmentButton>
          <SegmentButton
            active={mode === "manual"}
            onClick={() => onModeChange?.("manual")}
            disabled={isBusy}
          >
            Manual
          </SegmentButton>
        </div>

        <div
          className={[
            "ai-chat-local-manual-inputs",
            isManual ? "" : "ai-chat-local-manual-inputs--hidden",
          ].join(" ")}
        >
          <LocalKnobNumberInput
            value={min}
            onChange={onMinChange}
            onBlur={onMinBlur}
            disabled={!isManual || isBusy}
            min={512}
            max={128000}
            step={256}
            title="Min context tokens"
            placeholder="Min"
            tabIndex={isManual ? 0 : -1}
          />
          <span className="ai-chat-local-knob-dash">–</span>
          <LocalKnobNumberInput
            value={max}
            onChange={onMaxChange}
            onBlur={onMaxBlur}
            disabled={!isManual || isBusy}
            min={512}
            max={128000}
            step={256}
            title="Max context tokens"
            placeholder="Max"
            tabIndex={isManual ? 0 : -1}
          />
        </div>
      </div>
    </div>
  );
}

